<template>
  <div>
    <table-view
      ref="tableList"
      is-search-row
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="Business Role LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:;"
          class="icon-pencil1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="462px"
      @close="handleClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <div class="form-wrapper">
          <el-form :model="form" ref="form" label-position="top" :rules="rules">
            <el-form-item label="Region" prop="region">
              <el-select
                v-model="form.region"
                style="width: 100%"
                placeholder="please select"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="Analyst Dummy Account"
              prop="analystDummyAccount"
            >
              <el-select
                v-model="form.analystDummyAccount"
                style="width: 100%"
                filterable
                placeholder="please select"
              >
                <el-option
                  v-for="name in userList"
                  :key="name.id"
                  :label="name.username"
                  :value="name.username"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Other Dummy Account" prop="otherDummyAccount">
              <el-select
                v-model="form.otherDummyAccount"
                style="width: 100%"
                clearable
                filterable
                placeholder="please select"
              >
                <el-option
                  v-for="name in userList"
                  :key="name.id"
                  :label="name.username"
                  :value="name.username"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="E-mail Notification" prop="email">
              <el-input style="width: 100%" v-model="form.email" />
            </el-form-item>
            <el-form-item label="Business Role Name" prop="name">
              <el-input style="width: 100%" v-model="form.name" />
            </el-form-item>
            <el-form-item label="Business Role Description" prop="description">
              <el-input style="width: 100%" v-model="form.description" />
            </el-form-item>
            <el-form-item label="Status" prop="status">
              <el-select
                v-model="form.status"
                style="width: 100%"
                placeholder="please select"
              >
                <el-option label="Active" :value="1" />
                <el-option label="Disable" :value="2" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSave">
          Save
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSelectList } from '@/api'
const selectList = ['region']
import { getTableData, updateOrAdd, getAssign } from './api'

export default {
  data() {
    const tableModel = [
      {
        minWidth: 140,
        label: 'Region',
        prop: 'regionStr',
      },
      {
        width: 180,
        label: 'Analyst Dummy Account',
        prop: 'analystDummyAccount',
      },
      {
        width: 180,
        label: 'Other Dummy Account',
        prop: 'otherDummyAccount',
      },
      {
        width: 260,
        label: 'E-mail Notification',
        prop: 'email',
      },
      {
        width: 180,
        label: 'Business Role Name',
        prop: 'name',
      },
      {
        width: 190,
        label: 'Business Role Description',
        prop: 'description',
      },
      {
        width: 100,
        label: 'Status',
        prop: 'statusStr',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]
    return {
      tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        analystDummyAccount: '',
        otherDummyAccount: '',
        description: '',
        status: '',
        name: '',
        email: '',
        region: '',
      },
      rules: {
        analystDummyAccount: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        // otherDummyAccount: [
        //   { required: true, trigger: 'change', message: 'Can not be empty!' },
        // ],
        region: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        status: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        description: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        name: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
      },
      userList: [],
      assignLoading: false,
      regionList: [],
    }
  },
  created() {
    // 获取下拉列表
    this.getAllSelect()
  },
  mounted() {
    this.initTable()
    this._getAssign()
  },
  methods: {
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [region] = res
            this.regionList = region
            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.log(`search 列表查询错误:${err}`)
        })
    },
    // 异步请求下拉列表数据
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.log(err)
      }
    },
    async _getAssign() {
      try {
        this.userList = await getAssign()
      } catch (err) {
        console.log(err)
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleClose() {
      this.formId = ''
      this.$refs.form.resetFields()
    },
    async handleSave() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const submitData = { ...this.form }
        if (this.formId) submitData.id = this.formId
        await this.handleUpdateOrAdd(submitData)
      }
    },
    async handleUpdateOrAdd(params) {
      try {
        await updateOrAdd(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      this.visible = true
      this.$refs.form.resetFields()
    },
    handleEdit(row) {
      this.visible = true
      this.formId = row.id
      this.form = row
      const _obj = {}
      Object.keys(row).forEach(key => {
        _obj[key] = row[key]
      })
      this.form = _obj
    },
  },
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  display: flex;

  .form-wrapper {
    width: 350px;
  }

  .tree-wrapper {
    flex: 1;
    margin-left: 34px;
    padding-top: 12px;

    .tree-content {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      margin-top: 20px;

      border: 2px solid #dae0f2;
      border-radius: 4px;
    }
  }
}
</style>
